
import React from "react";
import { motion } from "framer-motion";

export const WhyWeBuiltSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-4 max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-[#1A1F2C] mb-6">
            Why We Built It
          </h2>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-6 order-2 md:order-1"
          >
            <p className="text-lg text-gray-700">
              We've spent years watching people we love walk away from the faith, 
              not because they hated God, but because they didn't have clarity.
            </p>
            
            <p className="text-lg text-gray-700">
              We've seen believers paralyzed by fear when it's time to share the gospel.
            </p>
            
            <p className="text-lg text-gray-700">
              We've seen churches struggle to disciple people in a digital age that moves 
              faster than they can keep up.
            </p>
            
            <p className="text-lg text-gray-700">
              So we built something that could speak into the silence. Not to replace pastors, 
              but to reinforce them. Not to replace Scripture, but to point to it. Not to 
              replace the Spirit, but to follow His lead.
            </p>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative order-1 md:order-2"
          >
            <img 
              src="https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//about%202.png" 
              alt="Why We Built Selah" 
              className="rounded-xl shadow-lg w-full"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
